<template>
  <tr class="pointer">
    <td>
      <slot name="state-column" />
    </td>
    <td v-if="!duplicatesMod">{{ purchaseCondition.ean }}</td>
    <td v-if="!duplicatesMod">{{ purchaseCondition.ref }}</td>
    <td>{{ purchaseCondition.designation }}</td>
    <td v-if="!duplicatesMod">{{ formatBeginDate(purchaseCondition.beginDate) }}</td>
    <td>{{ getBillingUnitLabel(purchaseCondition.billingUnit) }}</td>
    <td>{{ purchaseCondition.incoTerm }}</td>
    <td>{{ purchaseCondition.pcbPackaging }}</td>
    <td>{{ purchaseCondition.francoAmount }}</td>
    <td>{{ purchaseCondition.francoUnit }}</td>
    <td>{{ purchaseCondition.netPrice }}</td>
  </tr>
</template>

<script lang="ts">
import Vue from 'vue';
import { PurchaseCondition } from '@/models/purchase-condition/purchase-condition';
import { getFormattedDate } from '@/services/date-formater';
import { getBillingUnitLabel } from '@/models/purchase-condition/billing-unit';

export default Vue.extend({
  name: 'SelectionRow',
  props: {
    checked: {
      type: Boolean,
      default: false
    },
    duplicatesMod: {
      type: Boolean,
      default: false
    },
    purchaseCondition: {
      type: Object as () => PurchaseCondition,
      required: true
    }
  },
  methods: {
    getBillingUnitLabel,
    formatBeginDate(date: string): string {
      return getFormattedDate(date, '/');
    }
  }
});
</script>
